import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { sso } from "roboflex-thalamus-sso-lib";
import {
  api,
  registrarInterceptorTenant,
  syncTenantKey,
} from "roboflex-thalamus-request-handler";
import { limparSessao } from "@/services/sessionService";

import "./assets/css/thalamus.css";

api.defaults.baseURL = process.env.VUE_APP_ROOT_API;

/** Troca de tenant → reload completo (request-handler); não usa eventos in-app. */
registrarInterceptorTenant();

// Header/lib chama sso.logout(); em localhost o cookie é host-only e a lib não apaga.
sso.logout = limparSessao;

async function bootstrap() {
  // Evita chamadas duplicadas de /auth/me no boot.
  // O enriquecimento da sessão ocorre nos fluxos de login/callback e no guard de rotas protegidas.
  syncTenantKey();

  const app = createApp(App);
  app.use(router);
  await router.isReady();
  app.mount("#app");
}

bootstrap();
